"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Collapse = exports.AnimatedCollapse = exports.StaticCollapse = void 0;
const React = require("react");
const react_transition_group_1 = require("react-transition-group");
const cssComposer_1 = require("../../../../helpers/cssComposer");
const styles = require("./styles.scss");
const css = (0, cssComposer_1.default)(styles, "Collapse");
const anyWindow = window;
const animateCollapse = !(anyWindow.env.disableCollapse || anyWindow.disableCollapse);
const StaticCollapse = ({ isOpened, onClick, children }) => {
    return (React.createElement("div", { className: css(""), onClick: onClick, "data-test": "collapse" },
        React.createElement("div", { className: css("contents", isOpened ? "-open" : "-closed") }, children)));
};
exports.StaticCollapse = StaticCollapse;
const AnimatedCollapse = ({ isOpened, onClick, children, size = "lg" }) => {
    const transition = {
        appear: css(`transition-${size}Enter`),
        appearActive: css(`transition-${size}EnterActive`),
        enter: css(`transition-${size}Enter`),
        enterActive: css(`transition-${size}EnterActive`),
        exit: css(`transition-${size}Exit`),
        exitActive: css(`transition-${size}ExitActive`)
    };
    return (React.createElement("div", { className: css(""), onClick: onClick, "data-test": "collapse" },
        React.createElement(react_transition_group_1.TransitionGroup, null, isOpened && (React.createElement(react_transition_group_1.CSSTransition, { classNames: transition, timeout: 500 },
            React.createElement(React.Fragment, null, children))))));
};
exports.AnimatedCollapse = AnimatedCollapse;
exports.Collapse = animateCollapse
    ? exports.AnimatedCollapse
    : exports.StaticCollapse;
//# sourceMappingURL=index.js.map